import { Chip } from "@mui/material";
import ToolTip from "../../ToolTip/ToolTip";

export const LEAVE_GRANT_TABLE_HEAD = [
  {
    field: "sl_no",
    minWidth: 100,
    headerName: "Sl No",
  },
  {
    field: "userName",
    minWidth: 200,
    headerName: "Name",
  },
  {
    field: "leave_name_full",
    minWidth: 200,
    headerName: "Leave Type",
  },
  {
    field: "app_timestamp",
    minWidth: 200,
    headerName: "Applied On",
  },
  {
    field: "from_date",
    minWidth: 200,
    headerName: "From Date",
  },
  {
    field: "to_date",
    minWidth: 200,
    headerName: "To Date",
  },
  {
    field: "no_of_days",
    minWidth: 100,
    headerName: "No of Days",
  },
  {
    field: "reason",
    minWidth: 200,
    headerName: "Reason",
    renderCell: (params) => {
      return <ToolTip content={params.row.reason} expand={params.row.reason} />;
    },
  },
  {
    field: "hod_remarks",
    minWidth: 200,
    headerName: "HOD Remarks",
  },
  {
    field: "last_update_by_hod",
    minWidth: 200,
    headerName: "Last Updated By HOD",
  },
  {
    field: "hr_remarks",
    minWidth: 200,
    headerName: "HR Remarks",
  },
  {
    field: "last_update_by_hr",
    minWidth: 200,
    headerName: "Last Updated By HR",
  },
];
